import axios from 'axios';
import Qs from 'qs';
// http request 拦截器
axios.interceptors.request.use(
    config => {
            if(config.method  === 'post' && config.data.constructor !== FormData && config.headers['Content-Type'] != "application/json;charset=UTF-8"){
                config.data = Qs.stringify(config.data);
                config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
            }
        return config;
    },
    err => {
        return Promise.reject(err);
    });

axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        
        return Promise.reject(error);
    });

export default axios;
